export var SampleType;
(function (SampleType) {
    SampleType[SampleType["Cycle"] = 0] = "Cycle";
    SampleType[SampleType["Trigger"] = 1] = "Trigger";
})(SampleType || (SampleType = {}));
